import { ReactNode } from "react";

interface ReduxInitializerProps {
  children: ReactNode;
}

export function ReduxInitializer({ children }: ReduxInitializerProps) {
  // Redux initialization is now handled by individual hooks
  // (useFeed, useWishlist, useProfile, useMemories, useCalendar)
  // which fetch data on mount
  return children;
}
